import { isFundingMethod } from '../discovery/policy.js';
import { onrampManifest } from '../generated/manifest.js';
import { isFundingHostRouteEnabled } from '../host-routes.js';
import { accountFundingMethods, accountWithdrawalMethods, } from './method-limits.js';
export function accountAvailableMethods(options) {
    if (!options.masterEnabled)
        return [];
    const methods = (options.direction === 'onramp'
        ? accountFundingMethods(options.connection)
        : accountWithdrawalMethods(options.withdrawal)).flatMap((method) => method.available ||
        (options.direction === 'onramp' &&
            isFundingMethod(method.id) &&
            method.reason === 'connection_required' &&
            (options.connection.quoteContext?.methods.includes(method.id) ||
                options.connection.quoteContext?.connectionRequiredMethods?.includes(method.id)))
        ? [{ id: method.id, label: method.id, artwork: method.artwork }]
        : []);
    if (options.direction === 'offramp') {
        const manual = onrampManifest.host_routes.manual_withdraw;
        if (options.withdrawal?.source && manual.enabled && manual.surfaces.includes(options.surface))
            methods.push({ id: 'manual_withdraw', label: 'manual_withdraw', artwork: 'manual-withdraw' });
        return methods;
    }
    const providerMethods = onrampManifest.onramp.providers.moonpay.methods;
    if (options.connectedWallet &&
        providerMethods.wallet_connect.enabled &&
        providerMethods.wallet_connect.surfaces.includes(options.surface))
        methods.push({ id: 'wallet_connect', label: 'connected_wallet_title', artwork: 'wallet' });
    if (options.cryptoDeposit &&
        providerMethods.crypto_deposit.enabled &&
        providerMethods.crypto_deposit.surfaces.includes(options.surface))
        methods.push({ id: 'crypto_deposit', label: 'crypto_deposit_title', artwork: 'crypto' });
    if (options.connection.quoteContext?.context.destination &&
        isFundingHostRouteEnabled(onrampManifest, 'manual_transfer', options.surface, options.masterEnabled, true))
        methods.push({ id: 'manual_transfer', label: 'manual_transfer', artwork: 'manual-transfer' });
    if (options.exchanges.length > 0 &&
        providerMethods.cex_connect.enabled &&
        providerMethods.cex_connect.surfaces.includes(options.surface))
        methods.push({ id: 'cex_connect', label: 'exchange_transfer', artwork: 'exchange' });
    return methods;
}
/** Display-only rows never participate in quote or payment authorization. */
export function accountUnavailableMethods(options) {
    if (!options.masterEnabled)
        return [];
    if (options.direction === 'onramp' && !options.connection.quoteContext)
        return [];
    if (options.direction === 'offramp' && !options.withdrawal)
        return [];
    const displayed = new Set(accountAvailableMethods(options).map((method) => method.id));
    const methods = options.direction === 'onramp'
        ? accountFundingMethods(options.connection)
        : accountWithdrawalMethods(options.withdrawal);
    const discovery = options.connection.quoteContext;
    const reasons = new Map(options.direction === 'onramp'
        ? [
            ...(discovery?.unavailableMethods ?? []),
            ...(discovery?.unavailableBankMethods ?? []),
        ].map((entry) => [entry.method, entry.reason])
        : []);
    return methods.flatMap((method) => {
        const reason = reasons.get(method.id) ?? method.reason;
        return !displayed.has(method.id) && reason
            ? [{ id: method.id, label: method.id, artwork: method.artwork, reason }]
            : [];
    });
}
